import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  message = signal<string | null>(null);

  private timer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, delay: number = 3000): void {
    if (this.timer) clearTimeout(this.timer);
    this.message.set(message);
    this.timer = setTimeout(() => {
      this.message.set(null);
      this.timer = null;
    }, delay);
  }
}
